import { CSSProperties, useMemo } from 'react'
import { TextStyle } from '../../../types'

const useTextStyleCss = (textStyle?: TextStyle): CSSProperties | undefined => {
    const style = useMemo(() => {
        if (!textStyle) return

        return {
            color: textStyle.color,
            fontFamily: textStyle.fontFamily,
            fontWeight: textStyle.fontWeight || 'normal',
        }
    }, [
        textStyle?.color,
        textStyle?.fontFamily,
        textStyle?.fontSize,
        textStyle?.fontWeight,
        textStyle?.strokeColor,
        textStyle?.strokeSize,
    ])

    return style
}

export default useTextStyleCss
